import Page from '../empreendimentos/entregues'
export default Page
